import {showMessage} from "../appRedux/actions";

export const copyToClip = (text, dispatch) => {
    navigator.clipboard.writeText(text)
    dispatch(showMessage('Copy this text to clipboard'))
}